<template>
  <div class="custom-container" v-loading.fullscreen.lock="conversionPoint.isLoading">
    <el-container class="category-title my-2">Konversi Point</el-container>

    <el-row :gutter="20" class="mt-4">
      <el-col :lg="12" :md="12">
        <el-card class="mb-2" shadow="never">
          <el-row :gutter="20" class="mt-4">
            <el-col :lg="12" :md="12">
              <el-form :model="formKonversi" ref="formKonversi" label-width="80px" class="demo-ruleForm">
                <el-form-item
                  label="Amount"
                  prop="amount"
                  :rules="[
                    { type: 'number', message: 'Amount must be a number'}
                  ]"
                >
                  <el-col :span="21">
                    <el-input size="small" type="age" v-model.number="conversionPoint.data.amount" autocomplete="off"></el-input> 
                  </el-col>
                  <el-col :span="3">
                    IDR
                  </el-col>
                </el-form-item>
                
                <el-form-item>
                  <el-row type="flex" justify="end">
                    <el-col :span="8">
                      <el-button size="small" type="primary" @click="save">Submit</el-button>
                    </el-col>
                    <el-col :span="3">
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-form> 
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  components: {},
  data: () => ({
    formKonversi: {
      amount: 0
    }
  }),
  computed: {
    ...mapState({
      conversionPoint: state => state.conversionPoint.conversionPoint,
    })
  },
  methods: {
    ...mapActions({
      getConversionPoint: "conversionPoint/GetConversionPoint",
      updateConversionPoint: "conversionPoint/UpdateConversionPoint",
    }),
    save() {
      const payload = {
        amount: this.conversionPoint.data.amount,
      };
      this.updateConversionPoint(payload);
    },
  },
  created() {
    this.getConversionPoint();
  }
};
</script>

<style>
.demo-input-label {
    display: inline-block;
    width: 130px;
  }
</style>
